var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-button',{class:[_vm.skin === 'info' ? 'info' : '', _vm.isOpen ? 'open' : '', _vm.skin !== 'info' ? `md-${_vm.skin}` : '', _vm.raised ? 'md-raised' : '', _vm.dense ? 'md-dense' : '', _vm.isIcon ? 'md-icon-button' : '', _vm.isClean ? 'clean' : ''],attrs:{"disabled":_vm.disabled},on:{"click":_vm.emitClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }